import { createGameplayLoader } from '@everyturn/browser-runtime/loading';

export const gameplayLoader = createGameplayLoader();
